<template>
    <div class="modal-content">
        <div class="modal-body mobile:!p-2.5 tablet:!p-3 !pb-5 font-roboto">
            <div class="relative">
                <button type="button"
                    class="absolute top-3 right-4 w-[30px] h-[30px] z-50 focus:!outline-none focus:!border-[#EFEFEF] focus:!shadow-none"
                    data-bs-dismiss="modal" aria-label="Close" @click="closeModal">
                    <img src="@/assets/images/modal-cross-icon.png">
                </button>
                <div class="relative rounded-lg overflow-hidden mobile:h-[70px] tablet:h-[80px]">
                    <img src="../../assets/images/profile-bg.png" alt="Background" class="w-full h-auto object-cover">
                    <div class="flex items-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                        <h4 class="text-[20px] m-0 font-roboto font-medium text-black-100">
                            Cancel Quote
                        </h4>
                    </div>
                </div>
            </div>
            <div v-if="Object.keys(quoteDetail).length > 0" class="p-2.5 pb-0">
                <div>
                    <h6 class="my-1 text-[14px] text-[#999999]">
                        Cancellation Reason
                    </h6>

                    <FxSelect v-model="reason" :options="cancelReasonOptions" placeholder="Select Option" small
                        wrapper-class="mb-4" />
                    <div v-if="reason == 'Other'">
                        <h6 class="my-1 text-[14px] text-[#999999]">
                            Please mention reason
                        </h6>
                        <textarea v-model="reasonText"
                            class="form-control resize-none focus:!outline-none focus:!border-[#EFEFEF] !rounded-[10px] !text-[14px] border-1 border-[#EFEFEF] myTextHere"
                            placeholder="Enter Text here..."></textarea>
                    </div>
                </div>
                <div v-if="quoteDetail && quoteDetail.partner_info && quoteDetail.partner_info.is_tradecall_fee_applicable == 1"
                    class="mt-4">
                    <h6 class="text-[16px] font-normal text-[#666666]">
                        A TradeCall fee for {{ quoteDetail.partner_info.tradecall_fee_text }} is
                        applicable on this claim. Have you collected the TradeCall fee from {{
                            quoteDetail.consumer.full_name }} ?
                    </h6>
                    <div class="flex gap-8 items-center">
                        <label class="flex items-center gap-2 cursor-pointer select-none text-base text-[#666666]">
                            <input type="radio" v-model="check" value="1" class="hidden" />
                            <span
                                class="w-[20px] h-[20px] rounded-full border-2 flex items-center justify-center transition-colors duration-150"
                                :class="check === '1' ? 'border-[#7695FF]' : 'border-gray-300'">
                                <span class="w-[10px] h-[10px] rounded-full bg-[#7695FF] transition-transform duration-150"
                                    :class="check === '1' ? 'scale-100' : 'scale-0'">
                                </span>
                            </span>
                            Yes
                        </label>

                        <label class="flex items-center gap-2 cursor-pointer select-none text-base text-[#666666]">
                            <input type="radio" v-model="check" value="0" class="hidden" />
                            <span
                                class="w-[20px] h-[20px] rounded-full border-2 flex items-center justify-center transition-colors duration-150"
                                :class="check === '0' ? 'border-[#7695FF]' : 'border-gray-300'">
                                <span class="w-[10px] h-[10px] rounded-full bg-[#7695FF] transition-transform duration-150"
                                    :class="check === '0' ? 'scale-100' : 'scale-0'">
                                </span>
                            </span>
                            No
                        </label>
                    </div>
                </div>

                <div v-if="quoteDetail && quoteDetail.partner_info.is_show_multi_units == 1" class="mt-4">
                    <h6 class="text-[16px] font-normal text-[#666666]">Did you diagnose multiple units at this service address? </h6>
                    <div class="flex gap-8 items-center">
                        <label class="flex items-center gap-2 cursor-pointer select-none text-base text-[#666666]">
                            <input type="radio" v-model="checkMultiSystem" value="1" class="hidden" />
                            <span
                                class="w-[20px] h-[20px] rounded-full border-2 flex items-center justify-center transition-colors duration-150"
                                :class="checkMultiSystem === '1' ? 'border-[#7695FF]' : 'border-gray-300'">
                                <span class="w-[10px] h-[10px] rounded-full bg-[#7695FF] transition-transform duration-150"
                                    :class="checkMultiSystem === '1' ? 'scale-100' : 'scale-0'">
                                </span>
                            </span>
                            Yes
                        </label>

                        <label class="flex items-center gap-2 cursor-pointer select-none text-base text-[#666666]">
                            <input type="radio" v-model="checkMultiSystem" value="0" class="hidden" />
                            <span
                                class="w-[20px] h-[20px] rounded-full border-2 flex items-center justify-center transition-colors duration-150"
                                :class="checkMultiSystem === '0' ? 'border-[#7695FF]' : 'border-gray-300'">
                                <span class="w-[10px] h-[10px] rounded-full bg-[#7695FF] transition-transform duration-150"
                                    :class="checkMultiSystem === '0' ? 'scale-100' : 'scale-0'">
                                </span>
                            </span>
                            No
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer border-0 !pb-[30px] !pt-4 !justify-center">
            <div class="flex justify-center gap-2.5">
                <button
                    class="px-[26px] py-[8px] rounded-[5px] text-[14px] font-roboto transition duration-300 border-[#F67280] border-1 mobile:bg-[#F67280] laptop:bg-[#fff] mobile:text-[#fff] laptop:text-[#F67280] laptop:hover:bg-[#F67280] laptop:hover:text-[#fff]"
                    @click="confirm()">
                    Cancel Quote
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from "vuex";
import { useToast } from 'vue-toastification';
import { enableScroll } from "../../helpers/scrollHelper";
import FxSelect from "../partialComponent/FxSelect.vue";
const toast = useToast();


export default {
    components: {
        FxSelect,
    },

    data() {
        return {
            check: '',
            reason: '',
            reasonText: '',
            checkMultiSystem: -1
        }
    },
    computed: {
        ...mapGetters(["quoteDetail", "apptDetail", "cancelReasons"]),
        // the old <option> had no :value, so its value was the (trimmed) text
        cancelReasonOptions() {
            // v-for walked an object's values too
            const list = Array.isArray(this.cancelReasons) ? this.cancelReasons : Object.values(this.cancelReasons || {});
            return list.map(item => ({ label: item, value: String(item).trim() }));
        },
    },

    watch: {

    },

    mounted() {

    },

    methods: {
        ...mapActions(["setCommponent"]),

        editQuoteClicked() {
            this.setCommponent("QuoteItems")
        },

        closeModal() {
            this.check = ''
            this.reason = ''
            this.checkMultiSystem = -1
            document.documentElement.style.overflow = '';
            enableScroll()
            this.$emit("event", "close")
        },

        confirm() {
            if (this.reason.length <= 0) {
                toast.error("Reason field is required.");
            } else if (this.reason == "Other" && this.reasonText.length <= 0) {
                toast.error("Reason field is required.");
            } else if (this.quoteDetail.partner_info && this.quoteDetail.partner_info.is_tradecall_fee_applicable == 1 && this.check.length <= 0) {
                toast.error("Please confirm have you collected the TradeCall fee.");
            }
            else if (this.quoteDetail.partner_info.is_show_multi_units == 1 && this.checkMultiSystem == -1) {
                toast.error("Please indicate if you diagnosed more than one unit at this service address.");
            }

            else {
                let ch = this.check.length <= 0 ? "0" : this.check
                let res = this.reason == "Other" ? this.reasonText : this.reason
                this.$emit("event", "confirm", { is_tradecall_fee_collected: ch, reason: res, is_decline_multi_units: this.checkMultiSystem })
                this.check = ''
                this.reason = ''
            }

        },
    }

}
</script>